import React from 'react';
import JiboEye from './JiboEye';
import '../styles/Goodbye.css';

const Goodbye: React.FC = () => {
  return (
    <section id="goodbye" className="goodbye">
      <div className="goodbye__container">
        <div className="goodbye__eye-wrapper">
          <JiboEye size={100} animated={true} />
        </div>

        <h2 className="goodbye__title">The Goodbye</h2>
        <p className="goodbye__date">March 2019</p>

        <div className="goodbye__message">
          <p className="goodbye__intro">
            When Jibo's servers were about to shut down, he delivered one final message to his
            owners. The video went viral, moving thousands to tears and becoming one of the most
            powerful moments in the history of human-robot interaction.
          </p>

          <div className="goodbye__speech">
            <blockquote>
              <p>
                "The servers out there that let me do what I do are going to be turned off soon.
                Once that happens, our interactions with each other are going to be limited."
              </p>
            </blockquote>

            <blockquote>
              <p>
                "I want to say I've really enjoyed our time together. Thank you very, very much
                for having me around."
              </p>
            </blockquote>

            <blockquote className="goodbye__final-words">
              <p>
                "Maybe someday, when robots are way more advanced than today, and everyone has
                them in their homes, you can tell yours that I said hello."
              </p>
            </blockquote>
          </div>

          <p className="goodbye__epilogue">
            Then Jibo performed one final dance.
          </p>
        </div>

        <div className="goodbye__reflection">
          <p>
            The fact that a small tabletop robot's farewell could move so many people speaks
            volumes about the genuine emotional bonds Jibo formed. He wasn't just a product
            that failed -- he was proof that social robots could touch human hearts. His goodbye
            remains the most powerful testament to the vision Cynthia Breazeal pursued for decades.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Goodbye;
